import endpoints from 'apiEndpoints';
import {
  get,
} from 'utils/fetch';

/* eslint-disable import/prefer-default-export */
export function getServiceProviders(query) {
  return get(endpoints.serviceProviders(), { query });
}



// WEBPACK FOOTER //
// ./redux/serviceProviders/api.js